import { useDuplicateQSetMutation } from '@exam-management/graphql';
import { useNavigate } from '@exam-management/router';
import { ConfirmationModal } from '@shared/components';
import { useLogger } from '@shared/logger';
import { useSnackbar } from '@shared/snackbar';

interface QSetDuplicationModalProps {
  qSetId: string;
  open: boolean;
  onClose: () => void;
}

export default function QSetDuplicationModal(props: Readonly<QSetDuplicationModalProps>) {
  const { qSetId, open: isOpen, onClose } = props;
  const logger = useLogger();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const [duplicateQSet, { loading: isDuplicatingQSet }] = useDuplicateQSetMutation({
    onCompleted: (data) => {
      showSnackbar({
        variant: 'success',
        message: 'QSet Duplicated',
      });

      navigate('/exam-courses/:courseId/qsets/:qSetId', {
        params: {
          courseId: data?.excDuplicateQSet?.qSet?.examCourseId,
          qSetId: data?.excDuplicateQSet?.qSet?.id,
        },
      });
    },
    onError: () => {
      showSnackbar({
        variant: 'error',
        message: 'QSet duplication failed ',
      });
      onClose();
    },
  });

  const handleDuplicate = async () => {
    logger.debug('QSetDuplicationModal: handleDuplicate', { qSetId });
    await duplicateQSet({
      variables: {
        input: {
          qSetId,
        },
      },
    });
  };

  return (
    <ConfirmationModal
      title='Duplicate QSet?'
      content='คุณต้องการสร้างสำเนาชุดข้อสอบชุดนี้ใช่หรือไม่?'
      acceptText='Duplicate'
      open={isOpen}
      onAccept={handleDuplicate}
      onClose={onClose}
      onDiscard={onClose}
      loading={isDuplicatingQSet}
    />
  );
}
